import { createGlobalStyle } from 'styled-components';
import './variables.css';

const GlobalStyles = createGlobalStyle`
  * {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
  }
  
  html, body, #root {
    height: 100%;
  }
  
  body {
    font-family: 'Poppins', 'SF Pro Display', -apple-system, BlinkMacSystemFont, 'Segoe UI', 
                 Roboto, Oxygen, Ubuntu, Cantarell, 'Helvetica Neue', sans-serif;
    color: var(--text-primary);
    background-color: var(--bg-secondary);
    line-height: 1.6;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    font-size: var(--font-base);
  }
  
  h1, h2, h3, h4, h5, h6 {
    font-family: 'Cinzel', serif;
    margin-bottom: var(--space-sm);
    font-weight: 600;
    line-height: 1.3;
    letter-spacing: -0.02em;
  }
  
  h1 {
    font-size: var(--font-3xl);
    font-weight: 700;
  }
  
  h2 {
    font-size: var(--font-2xl);
  }
  
  h3 {
    font-size: var(--font-xl);
  }
  
  p {
    margin-bottom: var(--space-md);
  }
  
  a {
    color: var(--primary-color);
    text-decoration: none;
    transition: color var(--transition-fast);
    
    &:hover {
      color: var(--primary-dark);
    }
  }
  
  button, input, select, textarea {
    font-family: inherit;
    font-size: inherit;
    line-height: inherit;
  }
  
  button {
    cursor: pointer;
  }
  
  /* Custom scrollbar */
  ::-webkit-scrollbar {
    width: 8px;
    height: 8px;
  }
  
  ::-webkit-scrollbar-track {
    background: var(--bg-tertiary);
  }
  
  ::-webkit-scrollbar-thumb {
    background: var(--border-medium);
    border-radius: var(--radius-full);
  }
  
  ::-webkit-scrollbar-thumb:hover {
    background: var(--border-dark);
  }
  
  /* Form elements */
  input, select, textarea {
    padding: var(--space-sm) var(--space-md);
    border: 1px solid var(--border-medium);
    border-radius: var(--radius-md);
    background-color: var(--bg-light);
    transition: border-color var(--transition-fast), box-shadow var(--transition-fast);
    
    &:focus {
      outline: none;
      border-color: var(--primary-color);
      box-shadow: 0 0 0 3px var(--primary-light);
    }
  }
  
  /* Tables */
  table {
    width: 100%;
    border-collapse: collapse;
    margin-bottom: var(--space-lg);
  }
  
  th, td {
    padding: var(--space-sm) var(--space-md);
    border-bottom: 1px solid var(--border-light);
    text-align: left;
  }
  
  th {
    font-weight: 600;
    background-color: var(--bg-tertiary);
  }
  
  /* Utility classes */
  .text-center {
    text-align: center;
  }
  
  .text-right {
    text-align: right;
  }
  
  .text-muted {
    color: var(--text-tertiary);
  }
  
  .w-100 {
    width: 100%;
  }
  
  .mt-1 { margin-top: var(--space-xs); }
  .mt-2 { margin-top: var(--space-sm); }
  .mt-3 { margin-top: var(--space-md); }
  .mt-4 { margin-top: var(--space-lg); }
  .mt-5 { margin-top: var(--space-xl); }
  
  .mb-1 { margin-bottom: var(--space-xs); }
  .mb-2 { margin-bottom: var(--space-sm); }
  .mb-3 { margin-bottom: var(--space-md); }
  .mb-4 { margin-bottom: var(--space-lg); }
  .mb-5 { margin-bottom: var(--space-xl); }
`;

export default GlobalStyles; 